import setAttributes from './utility/set-attributes';

// UI
const shareableLinkUI = document.querySelector('#shareable-link');
const mainForm = document.querySelector('#main-form');
const currentTab = mainForm && mainForm.dataset ? mainForm.dataset.tab : undefined;

const shareableLinkPath = `/marc-${currentTab}?hash=`;
const shareableLinkApi = '/metadata/' + currentTab + '/encode';

// Listeners
function addShareableLinkButtonListener(metaDataUrl) {
	if (shareableLinkUI) {
		shareableLinkUI.addEventListener('click', event => {
			// Fix event preventDefault for ie
			if (event.preventDefault()) {
				event.preventDefault();
			} else {
				event.returnValue = false;
			}

			if (mainForm) {
				fetch(shareableLinkApi, {
					method: 'POST',
					body: urlencodeFormData(mainForm),
					credentials: 'include',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(response => {
					if (response.ok) {
						response.text()
							.then(shareable => {
								// Some browsers (mainly IE) does not have this property, so we need to build it manually
								if (!window.location.origin) {
									window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
								}
								const generatedLink = window.location.origin + shareableLinkPath + shareable;
								displayHtmlElements(generatedLink);
							});
					} else if (response.status === 400) {
						console.log('response 400');
					} else {
						throw new Error('Unknown status code');
					}
				}).catch(err => {
					console.log(err);
				});
			}
		});
	}
}

function addCopyLinkButtonListener() {
	const copyShareableLinkButton = document.querySelector('#button-copy-link');
	if (copyShareableLinkButton) {
		copyShareableLinkButton.addEventListener('click', copyShareableLinkToClipboard);
	}
}

function displayHtmlElements(link) {
	shareableLinkUI.remove();

	const nodeInput = document.createElement('input');
	nodeInput.value = link;
	nodeInput.classList.add('c-shareable-link__generate-link');
	setAttributes(nodeInput, {
		id: 'generated-shareable-link',
		readonly: 'true'
	});
	document.querySelector('#shareable-link-wrapper').append(nodeInput);

	const nodeCopy = document.createElement('a');
	const textCopy = document.createTextNode('Copy Shareable Link');
	nodeCopy.append(textCopy);
	nodeCopy.classList.add('c-shareable-link__copy-link');
	nodeCopy.setAttribute('id', 'button-copy-link');
	document.querySelector('#shareable-link-wrapper').append(nodeCopy);

	addCopyLinkButtonListener();
}

function copyShareableLinkToClipboard() {
	const copyText = document.querySelector('#generated-shareable-link');
	copyText.select();
	try {
		return document.execCommand('Copy');
	} catch (err) {
		console.warn('Copy to clipboard failed.', err);
		// eslint-disable-next-line no-alert
		alert('Copy to clipboard failed.', err);
		return false;
	} finally {
		document.querySelector('#button-copy-link').remove();
		const nodeFeedback = document.createElement('div');
		nodeFeedback.setAttribute('id', 'shareable-link__feedback-wrapper');
		nodeFeedback.classList.add('c-shareable-link__feedback-container');
		document.querySelector('#shareable-link-wrapper').append(nodeFeedback);
		const feedMarkup = `<p class="c-shareable-link__feedback-message-positive">Link has been copied!</p>`;
		document.querySelector('#shareable-link__feedback-wrapper').innerHTML = feedMarkup;
	}
}

// Utils
function encode(s) {
	return encodeURIComponent(s).replaceAll('%20', '+');
}

function urlencodeFormData(formElement) {
	const formData = new FormData(formElement);
	let s = '';
	for (const pair of formData.entries()) {
		if (typeof pair[1] === 'string') {
			s += (s ? '&' : '') + encode(pair[0]) + '=' + encode(pair[1]);
		}
	}
	return s;
}

function init(metaDataUrl) {
	addShareableLinkButtonListener(metaDataUrl);
}

export default {init};
